import { render } from "./CardResi.vue?vue&type=template&id=21bb5166"
import script from "./CardResi.vue?vue&type=script&lang=js"
export * from "./CardResi.vue?vue&type=script&lang=js"
script.render = render

export default script